import { type EditorSDK } from '@wix/wix-data-client-common-standalone'
import { PAGE_LINK_FIELD_PREFIX } from './constants'
import {
  getAllPageLinkIds,
  type RouterConfig,
} from '@wix/wix-data-client-common'

const MAX_ATTEMPTS = 5

export const generateUniquePageLinkId = async ({
  editorSdkProxy,
}: {
  editorSdkProxy: EditorSDK
}): Promise<string> => {
  const routers = await editorSdkProxy.routers.getAll<RouterConfig>()
  const existingPageLinkIds = getAllPageLinkIds(routers)

  let attempts = 0

  do {
    const suffix = Math.random().toString(36).substring(2, 7)
    const pageLinkId = PAGE_LINK_FIELD_PREFIX + suffix

    if (!existingPageLinkIds.includes(pageLinkId)) {
      return pageLinkId
    }

    attempts++
  } while (attempts < MAX_ATTEMPTS)

  throw new Error(
    'Failed to generate unique page link id after multiple attempts',
  )
}
